import { __rest, __assign } from 'tslib';
import React__default, { useEffect } from 'react';
import clsx from 'clsx';
import { logger } from '../../util/_internal/logger.js';
import { replacement, propTypes, defaultProps } from './Text.types.js';
import styles from './Text.module.scss.js';

var Text = function (_a) {
    var type = _a.type, className = _a.className, color = _a.color, Component = _a.as, size = _a.size, textRef = _a.textRef, fontSize = _a.fontSize, underline = _a.underline, isBold = _a.isBold, rest = __rest(_a, ["type", "className", "color", "as", "size", "textRef", "fontSize", "underline", "isBold"]);
    useEffect(function () {
        if (replacement[type]) {
            logger.warn("DEPRECATION WARNING: The ".concat(type, " 'type' is deprecated, please use ").concat(replacement[type], "."));
        }
    }, [type]);
    var isLarge = size === 'large';
    var classes = clsx(styles["".concat(type).concat(isLarge ? 'Large' : '').concat(isBold ? '___bold' : '')], className);
    var style = { color: color, fontSize: fontSize };
    if (underline) {
        style.textDecoration = 'underline';
    }
    if (Component) {
        return React__default.createElement(Component, __assign({ className: classes, style: style }, rest));
    }
    var props = __assign({ className: classes, ref: textRef, style: style }, rest);
    switch (type) {
        case 'h1':
            return React__default.createElement("h1", __assign({}, props));
        case 'h2':
            return React__default.createElement("h2", __assign({}, props));
        case 'h3':
            return React__default.createElement("h3", __assign({}, props));
        case 'h4':
            return React__default.createElement("h4", __assign({}, props));
        case 'h5':
            return React__default.createElement("h5", __assign({}, props));
        case 'h6':
        case 'sub1':
        case 'sub2':
        case 'sub3': // deprecated
            return React__default.createElement("h6", __assign({}, props));
        case 'label':
        case 'label1': // deprecated
        case 'label2': // deprecated
            return React__default.createElement("label", __assign({}, props));
        case 'number':
        case 'defaultButton':
        case 'smallButton':
        case 'primarybtn': // deprecated
        case 'tertiarybtn': // deprecated
        case 'hyperlink': // deprecated
        case 'bold': // deprecated
            return React__default.createElement("span", __assign({}, props));
        case 'p':
        case 'boldParagraph': // deprecated
        case 'overline': // deprecated
        case 'legal': // deprecated
        default:
            return React__default.createElement("p", __assign({}, props));
    }
};
Text.displayName = 'Text';
Text.propTypes = propTypes;
Text.defaultProps = defaultProps;

export { Text as default };
